import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';


import {
    MODEL_CLEANUP,
    UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SHOW_SCREEN,
    MODEL_PERIODIC_SUMMARY_SETTINGS_MANAGEMENT_ERROR,
    MODEL_PERIODIC_SUMMARY_SETTINGS_IS_LOADING,
    GET_ALL_MODEL_PERIODIC_SUMMARY_SETTINGS,
    SET_MODEL_PERIODIC_SUMMARY_SETTINGS_DETAILS,
    SET_MODEL_PERIODIC_SUMMARY_SETTINGS_CHANGE,
    UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SAVE_STATUS,
    MODELPERIODICSUMMARYSETTINGS_SET_FILTERED_RESULTS,
    MODELPERIODICSUMMARYSETTINGS_SET_PAGE_FILTER,
    MODELPERIODICSUMMARYSETTINGS_SET_CURRENT_PAGE
} from '../constants/index';

import {
    PERIODICSUMMARYSETTINGS_MANAGEMENT,
    CREATE_PERIODICSUMMARYSETTINGS,
    UPDATE_PERIODICSUMMARYSETTINGS,
    DELETE_PERIODICSUMMARYSETTINGS,
    UPLOAD_PERIODICSUMMARYSETTINGS
} from '../constants/logs';


const envName = process.env.REACT_APP_ENV_NAME_SHORT;

//Periodic Summary settings
//====================
export const setPeriodicSummarySettingsErrorThunk = err => dispatch => {
    let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
    messageCode = messageCode && messageCode.replace('[400]=>', '');
    dispatch(setPeriodicSummarySettingsError(messageCode, true));
    setTimeout(() => {
        //Hide the banner
        dispatch(setPeriodicSummarySettingsError(messageCode, false));
    }, 2500);
};

export const setPeriodicSummarySettingsError = (messageCode, status) => {
    return {
        type: MODEL_PERIODIC_SUMMARY_SETTINGS_MANAGEMENT_ERROR,
        payload: {
            data: {
                isOpSuccessfull: false,
                showBanner: status,
                isLoading: false,
                displayMessageCode: messageCode || ''
            }
        }
    };
};

export const getPeriodicSummarySettingsThunk = (offset, limit, filter, modelCategoryId, modelId, widgetCode) => dispatch => {
    if (modelId) {
        dispatch(getPeriodicSummarySettings(offset, limit, filter, modelCategoryId, modelId, widgetCode));
    }
};

export const setPeriodicSummarySettingsLoadingStatus = isLoading => ({
    type: MODEL_PERIODIC_SUMMARY_SETTINGS_IS_LOADING,
    payload: { isLoading: isLoading }
});

export const getPeriodicSummarySettings = (offset, limit, filter, modelCategoryId, modelId, widgetCode) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/model/periodicsummarysettings`,
        data: {
            Offset: offset,
            Limit: limit,
            Filter: filter,
            ModelId: modelId,
            ModelCategoryId: modelCategoryId
        },
        method: 'GET',
        onLoad: status => setPeriodicSummarySettingsLoadingStatus(status),
        onSuccess: retData => setAllPeriodicSummarySettingsListThunk(retData),
        onFailure: err => setPeriodicSummarySettingsErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        widgetcode: widgetCode
    });

export const setAllPeriodicSummarySettingsListThunk = retData => dispatch => {
    let messageCode = retData && retData.message;
    let periodicSummarySettings = (retData && retData.periodicSummarySettings) || [];
    dispatch(setAllPeriodicSummarySettingsList(messageCode, periodicSummarySettings));
};

export const setAllPeriodicSummarySettingsList = (messageCode, periodicSummarySettings) => ({
    type: GET_ALL_MODEL_PERIODIC_SUMMARY_SETTINGS,
    payload: {
        data: {
            PeriodicSummarySettingsList: periodicSummarySettings,
            isLoading: false,
            displayMessageCode: messageCode,
            showBanner: false
        }
    }
});

export const describePeriodicSummarySettingThunk = (modelCategoryId, modelId, periodicSummarySettingId, widgetCode) => dispatch => {
    dispatch(describePeriodicSummarySetting(modelCategoryId, modelId, periodicSummarySettingId, widgetCode));
};

export const describePeriodicSummarySetting = (modelCategoryId, modelId, periodicSummarySettingId, widgetCode) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/model/periodicsummarysettings`,
        data: {
            PeriodicSummarySettingId: periodicSummarySettingId || undefined,
            ModelCategoryId: modelCategoryId,
            ModelId: modelId
        },
        method: 'GET',
        onLoad: status => setPeriodicSummarySettingsLoadingStatus(status),
        onSuccess: retData => setdescribePeriodicSummarySettingThunk(retData),
        onFailure: err => setPeriodicSummarySettingsErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        widgetcode: widgetCode
    });

export const setdescribePeriodicSummarySettingThunk = retData => dispatch => {
    dispatch(setDescribePeriodicSummarySetting(retData));
};

export const setDescribePeriodicSummarySetting = retData => ({
    type: SET_MODEL_PERIODIC_SUMMARY_SETTINGS_DETAILS,
    payload: retData
});

export const setPeriodicSummarySettingChangeThunk = retData => dispatch => {
    dispatch(setPeriodicSummarySettingChange(retData));
};

export const setPeriodicSummarySettingChange = retData => ({
    type: SET_MODEL_PERIODIC_SUMMARY_SETTINGS_CHANGE,
    payload: retData
});

export const postPeriodicSummarySettingThunk = (periodicSummarySetting, widgetCode) => dispatch => {
    let url = '/management/model/periodicsummarysettings/save';
    let actionName = periodicSummarySetting.MarkAsDeleted
        ? DELETE_PERIODICSUMMARYSETTINGS
        : periodicSummarySetting.PeriodicSummarySettingId === 0
            ? CREATE_PERIODICSUMMARYSETTINGS
            : UPDATE_PERIODICSUMMARYSETTINGS;
    let log = logEntry(PERIODICSUMMARYSETTINGS_MANAGEMENT, actionName, periodicSummarySetting);
    dispatch(savePeriodicSummarySetting(periodicSummarySetting, url, log, widgetCode));
};

export const savePeriodicSummarySetting = (periodicSummarySetting, url, log, widgetCode) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}${url}`,
        method: 'POST',
        onLoad: status => setPeriodicSummarySettingsLoadingStatus(status),
        onSuccess: retData => setPeriodicSummarySettingStatusThunk(retData),
        onFailure: err => setPeriodicSummarySettingsErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        data: {
            periodicSummarySetting: { ...periodicSummarySetting },
            log: log
        },
        widgetcode: widgetCode
    });

export const setPeriodicSummarySettingStatusThunk = retData => dispatch => {
    let messageCode = retData && retData.message;
    let periodicSummarySettings = (retData && retData.periodicSummarySettings) || [];

    dispatch(setPeriodicSummarySettingStatusAndData(messageCode, periodicSummarySettings, true));
    setTimeout(() => {
        //Hide the banner
        dispatch(setPeriodicSummarySettingStatus('', false));
    }, 2500);
};

export const setPeriodicSummarySettingStatusAndData = (messageCode, data, status) => ({
    type: UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SAVE_STATUS,
    payload: {
        data: {
            PeriodicSummarySettingsList: data,
            isOpSuccessfull: true,
            showBanner: status,
            isLoading: false,
            showAddEditScreen: false,
            displayMessageCode: messageCode || ''
        }
    }
});

export const setPeriodicSummarySettingStatus = (messageCode, status) => ({
    type: UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SAVE_STATUS,
    payload: {
        data: {
            isOpSuccessfull: true,
            showBanner: status,
            isLoading: false,
            displayMessageCode: messageCode || ''
        }
    }
});


export const setCurrentPage = currentPage => ({
    type: MODELPERIODICSUMMARYSETTINGS_SET_CURRENT_PAGE,
    payload: { currentPage }
});

export const setPageFilter = filter => ({
    type: MODELPERIODICSUMMARYSETTINGS_SET_PAGE_FILTER,
    payload: { filter }
});


export const setModelPeriodicSummaryFilteredDataThunk = retData => dispatch => {
    dispatch(setModelPeriodicSummaryFilteredData(retData));
};

export const setModelPeriodicSummaryFilteredData = retData => ({
    type: MODELPERIODICSUMMARYSETTINGS_SET_FILTERED_RESULTS,
    payload: retData
});


export const setPeriodicSummarySettingShowScreenStatusThunk = status => dispatch => {
    dispatch(setPeriodicSummarySettingShowScreenStatus(status));
};

export const setPeriodicSummarySettingShowScreenStatus = status => ({
    type: UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SHOW_SCREEN,
    payload: { showAddEditScreen: status }
});

export const modelCleanUpThunk = model => dispatch => {
    dispatch(modelCleanUp(model));
};

export const modelCleanUp = model => ({
    type: MODEL_CLEANUP,
    payload: {
        data: model
    }
});


export const uploadPeriodicSettingToS3AndUpdateShadowThunk = (modelCategoryId, modelId, widgetCode) => dispatch => {
  let url = `/management/modelvariant/updateunitshadow`;
  let actionName = UPLOAD_PERIODICSUMMARYSETTINGS;
  let log = logEntry(UPLOAD_PERIODICSUMMARYSETTINGS, actionName, modelId);
  dispatch(uploadPeriodicSettingsToS3UpdateShadow(modelCategoryId, modelId, url, log, widgetCode));
};

export const uploadPeriodicSettingsToS3UpdateShadow = (modelCategoryId, modelId, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setPeriodicSummarySettingsLoadingStatus(status),
    onSuccess: retData => setUploadPeriodicSettingsToS3UpdateShadowStatusThunk(retData),
    onFailure: err => setPeriodicSummarySettingsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      uploadPeriodicSummarySettings: true,
      ModelCategoryId: modelCategoryId,
      ModelId: modelId,
      UpdatedBy: Cookies.get(`userid-${envName}`),
      log: log
    },
    widgetcode: widgetCode
  });

export const setUploadPeriodicSettingsToS3UpdateShadowStatusThunk = retData => dispatch => {
  let messageCode = retData && retData.message;

  dispatch(setUploadPeriodicSettingsToS3UpdateShadowStatus(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setUploadPeriodicSettingsToS3UpdateShadowStatus('', false));
  }, 2500);
};

export const setUploadPeriodicSettingsToS3UpdateShadowStatus = (messageCode, status) => ({
  type: UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});
